import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Assets
import {greyishBlue500, infoColor} from "assets/jss/main";

TrackingNumberBlue.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
};

function TrackingNumberBlue({trackingNumber}) {
    return (
        <span
            style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: greyishBlue500
            }}
        >
            <FormattedMessage id='wms.cc.list.takeoutShipment.popup.trackingNumber' />
            <span style={{ color: infoColor}}>{trackingNumber}</span>
        </span>
    );
}

export default TrackingNumberBlue;
